import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import axios from "axios";
import { FiInstagram } from "react-icons/fi";

import "./Instagram.css";


const Instagram = () => {
    const [insta, setInsta] = useState([]);

    useEffect(() => {
        axios
            .get(
                // "https://graph.instagram.com/me/media?fields=media_url,permalink&access_token=IGQVJVdFE0QWhUZA3g3a1VxYUdIQTRNS2xlU3ZAVa1dQSWlWSG81NGpHM2ZADM2RFcmJfLVVBdTA2el9iWTE1YUE1VE5SbTB2V3I4eGFMc2VSSl9OV1NRUXA2c1Jpajk2NDBTenBrc2ZAkNFZAWTlo3S25XMQZDZD"
                "https://graph.instagram.com/me/media?fields=media_url,permalink&access_token=IGQVJWNkRUby1EQ2dDckF3eDhxakV6dlNQZA212ZAW1faE5IZAU1xRDZAHOTdYWDZAyOG9VNVZApM2d5ZAWRtU3hTTzRVN0xLOXJCa1lWSThZAQ3NaSXBwYUxudFRyOVFpN0ZAGQlkwamRIS2lhdFQ1Y3NzLUNVOQZDZD"
            )
            // .then((data) => console.log(data.data))
            .then((data) => {
                const photosArray = data.data.data;
                setInsta(photosArray);
                // console.log(data.data.data[0].media_url)
                console.log(photosArray[0]);
            });
    }, []);

    return (
        <>
            <div className="insta-header">
            <hr className="hr4" />
                <div className="insta-foto">
                    <div className="insta-div">
                        <p className="p-insta">
                            <a href="https://www.instagram.com/przemekokocinski">
                                <FiInstagram style={{fontSize: "13px"}} />
                                przemekokocinski
                            </a>
                        </p>
                    </div>

                    <div className="insta-card">
                    {insta.slice(0, 6).map((photo, index) => (
                        <a href={photo.permalink}>
                            <img
                                // height="200px"
                                // width="200px"
                                className="insta-img"
                                key={photo.id}
                                src={photo.media_url}
                            />
                        </a>
                    ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Instagram;
